import type { ForgeCDNEnvironment, ProductEnvironment } from '@atlassian/forge-ui-types';

import { createAtlAttributionHeader, getCDNEnvironment } from '../../utils';

const globalEdgeUrlMap: Record<ForgeCDNEnvironment, string> = {
	dev: 'dev.services.atlassian.com',
	stg: 'stg.services.atlassian.com',
	prod: 'services.atlassian.com',
};

const getBaseUrl = (environment: ForgeCDNEnvironment): string => {
	const baseUrl = globalEdgeUrlMap[environment];

	if (!baseUrl) {
		throw new Error(`Invalid environment: ${environment}`);
	}

	const service = 'forge-outbound-proxy';

	const url = `https://${service}.${baseUrl}`;
	return url;
};

export const getFeatureFlags = async (
	appId: string,
	user: any,
	config: any,
	environment: ProductEnvironment,
	contextToken?: string,
): Promise<any> => {
	const init: RequestInit = {
		method: 'POST',
		headers: {
			'atl-attribution': createAtlAttributionHeader(),
			'Content-Type': 'application/json',
			Authentication: `Bearer ${contextToken}`,
		},
		body: JSON.stringify({
			user,
			config,
			appId,
		}),
	};

	const url = getBaseUrl(getCDNEnvironment(environment)) + '/client/feature-flags';
	const response = await fetch(url, init);

	if (!response.ok) {
		throw new Error(`HTTP error! status: ${response.status}`);
	}
	return response.json();
};
